import { ChangeEvent, FC, useCallback, useRef } from "react";
import moment from "moment";
import ButtonSmall from "../../F7/ButtonSmall";
import { Field } from "../FieldHandler";

const DateField: FC<{
  field: Field & { type: "date" };
  onChange: (key: string, value: string | null | undefined) => void;
}> = (props) => {
  const { field, onChange } = props;

  const toggleButtonRef = useRef(1);
  const originRef = useRef(field.value);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const id = field.key;
      const val = e.target.value;
      onChange(id, val);
    },
    [field, onChange]
  );

  const handleDateClick = useCallback(() => {
    let value: string | null | undefined = moment().format("YYYY-MM-DD");
    switch (toggleButtonRef.current) {
      case 1:
        value = moment().format("YYYY-MM-DD");
        toggleButtonRef.current++;
        break;
      case 2:
        if (value === originRef.current) {
          value = "";
          toggleButtonRef.current = 1;
          break;
        } else {
          value = originRef.current;
          toggleButtonRef.current++;
          break;
        }
      case 3:
        value = "";
        toggleButtonRef.current = 1;
        break;
      default:
        break;
    }
    onChange(field.key, value);
  }, [field, onChange]);

  const val = !field.value && field.required ? moment().format("YYYY-MM-DD") : field.value;
  return (
    <span>
      <div
        style={{
          paddingRight: 40,
        }}
      >
        <input type="date" value={val || ""} placeholder={field.required ? "required" : ""} onChange={handleChange} />
      </div>
      <div
        style={{
          float: "right",
          marginTop: -37,
        }}
      >
        <ButtonSmall onClick={handleDateClick}>
          <i
            className="fa fa-calendar-o"
            style={{
              color: "white",
            }}
          />
        </ButtonSmall>
      </div>
    </span>
  );
};

export default DateField;
